"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthService = void 0;

var lodash_1 = require("lodash");

var browser_or_node_1 = require("browser-or-node");

var framework_1 = require("../../core/framework");

var Storage_1 = __importDefault(require("../../core/utilities/Storage"));

var LegalizeSDKError_1 = __importDefault(require("../../core/utilities/LegalizeSDKError"));

var services_1 = require("../../services");

var enums_1 = require("../../enums");

var entities_1 = require("../../entities");

var Repository_1 = __importDefault(require("./Repository"));

var AuthServiceStorage;

(function (AuthServiceStorage) {
  AuthServiceStorage["location"] = "location";
  AuthServiceStorage["address"] = "address";
  AuthServiceStorage["token"] = "token";
})(AuthServiceStorage || (AuthServiceStorage = {}));

var AuthService =
/** @class */
function (_super) {
  __extends(AuthService, _super);

  function AuthService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.storage = new Storage_1.default("AuthService");
    _this.repository = new Repository_1.default();
    _this._token = "";
    _this._user = new entities_1.UserEntity();
    _this._state = enums_1.AuthServiceState.resume;
    _this._otpPhone = null;
    return _this;
  }

  AuthService.prototype.setBaseUrl = function (baseUrl) {
    this.baseUrl = baseUrl;
    this.repository.setBaseUrl(baseUrl);
  };

  AuthService.prototype.getLocationByCoordinates = function (lat, lng) {
    return this.repository.getLocationByCoordinates(lat, lng).then(function (data) {
      return Promise.resolve(new entities_1.PlacePredictionEntity({
        placeId: lodash_1.get(data, "placeDetailsByLocation.placeId", ""),
        description: lodash_1.get(data, "placeDetailsByLocation.address", "")
      }));
    });
  };

  AuthService.prototype.getLocation = function () {
    var location = this.storage.get(AuthServiceStorage.location);

    if (location) {
      return new entities_1.PlacePredictionEntity(location);
    }
  };

  AuthService.prototype.setLocation = function (location) {
    return __awaiter(this, void 0, void 0, function () {
      var token;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.storage.put(AuthServiceStorage.location, location);

            if (browser_or_node_1.isBrowser) {
              document.cookie = "placeId=" + location.placeId + "; path=/";
            }

            token = this.getToken();
            if (!token) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.createAddress(location, token)];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            this.emit("locationChanged", location);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AuthService.prototype.removeLocation = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.storage.remove(AuthServiceStorage.location);
        this.emit("locationChanged");
        return [2
        /*return*/
        ];
      });
    });
  };

  AuthService.prototype.resume = function () {
    return __awaiter(this, void 0, void 0, function () {
      var token, location_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 5,, 7]);

            token = this.storage.get(AuthServiceStorage.token);
            if (!token) throw "token not found";
            this._token = token;
            this.meService = new services_1.MeService(this.baseUrl, token);
            return [4
            /*yield*/
            , this.updateUser()];

          case 1:
            _a.sent();

            location_1 = this.getLocation();
            if (!location_1) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.updateAddress(location_1, token)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [4
            /*yield*/
            , this.setState(enums_1.AuthServiceState.authenticated)];

          case 4:
            return [2
            /*return*/
            , _a.sent()];

          case 5:
            error_1 = _a.sent();
            return [4
            /*yield*/
            , this.setState(enums_1.AuthServiceState.unauthenticated)];

          case 6:
            return [2
            /*return*/
            , _a.sent()];

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AuthService.prototype.sendOTP = function (phone, marketId) {
    return __awaiter(this, void 0, void 0, function () {
      var error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4,, 5]);

            return [4
            /*yield*/
            , this.repository.sendOTP(phone, marketId)];

          case 1:
            _a.sent();

            return [4
            /*yield*/
            , this.setOtpPhone(phone)];

          case 2:
            _a.sent();

            return [4
            /*yield*/
            , this.setState(enums_1.AuthServiceState.waitOTP)];

          case 3:
            return [2
            /*return*/
            , _a.sent()];

          case 4:
            error_2 = _a.sent();
            throw new LegalizeSDKError_1.default("AuthService: can not sendOTP", error_2);

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AuthService.prototype.confirmOTP = function (phone, marketId, otp) {
    var _a;

    return __awaiter(this, void 0, void 0, function () {
      var data, token, location_2, error_3;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 7,, 8]);

            return [4
            /*yield*/
            , this.repository.confirmOTP(phone, marketId, otp)];

          case 1:
            data = _b.sent();
            token = (_a = data === null || data === void 0 ? void 0 : data.otpLogin) === null || _a === void 0 ? void 0 : _a.token;
            return [4
            /*yield*/
            , this.setOtpPhone(null)];

          case 2:
            _b.sent();

            this.saveToken(token);
            this.meService = new services_1.MeService(this.baseUrl, token);
            return [4
            /*yield*/
            , this.updateUser()];

          case 3:
            _b.sent();

            location_2 = this.getLocation();
            if (!location_2) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , this.updateAddress(location_2, token)];

          case 4:
            _b.sent();

            _b.label = 5;

          case 5:
            return [4
            /*yield*/
            , this.setState(enums_1.AuthServiceState.authenticated)];

          case 6:
            return [2
            /*return*/
            , _b.sent()];

          case 7:
            error_3 = _b.sent();
            throw new LegalizeSDKError_1.default("AuthService: can not confirmOTP", error_3);

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AuthService.prototype.logout = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.storage.remove(AuthServiceStorage.token);
            this._token = "";
            this._user = new entities_1.UserEntity();
            this.meService = undefined;
            return [4
            /*yield*/
            , this.setState(enums_1.AuthServiceState.unauthenticated)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  AuthService.prototype.getToken = function () {
    return this._token;
  };

  AuthService.prototype.getState = function () {
    return this._state;
  };

  AuthService.prototype.getUser = function () {
    return this._user;
  };

  AuthService.prototype.getOtpPhone = function () {
    return this._otpPhone;
  };

  AuthService.prototype.updateUser = function () {
    return __awaiter(this, void 0, void 0, function () {
      var user;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.meService) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.meService.getUser()];

          case 1:
            user = _a.sent();
            this._user = user;
            return [2
            /*return*/
            , user];

          case 2:
            return [2
            /*return*/
            , this.getUser()];
        }
      });
    });
  };

  AuthService.prototype.setState = function (state) {
    this._state = state;
    this.emit("stateChanged", state);
    return Promise.resolve();
  };

  AuthService.prototype.saveToken = function (token) {
    this._token = token;
    this.storage.put(AuthServiceStorage.token, token);
  };

  AuthService.prototype.setOtpPhone = function (otpPhone) {
    this._otpPhone = otpPhone;
    return Promise.resolve();
  };

  AuthService.prototype.createAddress = function (location, token, note) {
    var _this = this;

    return new services_1.AddressService(this.baseUrl, token).create(location.placeId, note || "", "").then(function (address) {
      return Promise.resolve(_this.storage.put(AuthServiceStorage.address, address));
    });
  };

  AuthService.prototype.updateAddress = function (location, token) {
    return !this.getAddress() ? this.createAddress(location, token) : Promise.resolve();
  };

  AuthService.prototype.getAddress = function () {
    var address = this.storage.get(AuthServiceStorage.address);

    if (address) {
      return new entities_1.AddressEntity(address);
    }
  };

  return AuthService;
}(framework_1.Observer);

exports.AuthService = AuthService;